/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Sorgeberechtigtekinder1Inputs */



/**

* @param {_Field_Sorgeberechtigtekinder1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_sorgeberechtigtekinder1 = /** @type {((inputs?: _Field_Sorgeberechtigtekinder1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Sorgeberechtigtekinder1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Sorgeberechtigung für Kinder")
});
export { _field_sorgeberechtigtekinder1 as "_field_sorgeberechtigteKinder" }